import { useCallback, useEffect, useState } from "react";

/**
 * This hook for detect current screen size media query.
 *
 * @param {string} query Media query like css, for example `useMediaQuery("(min-width: 1920px)")`
 * @return {boolean}
 */
export const useMediaQuery = (query) => {
  const getMatches = useCallback((query) => {
    if (typeof window !== "undefined") {
      return window.matchMedia(query).matches;
    }

    return false;
  }, []);

  const [matches, setMatches] = useState(getMatches(query));

  function handleChange() {
    setMatches(getMatches(query));
  }

  useEffect(() => {
    const matchMedia = window.matchMedia(query);

    handleChange();

    if (matchMedia.addListener) {
      matchMedia.addListener(handleChange);
    } else {
      matchMedia.addEventListener("change", handleChange);
    }

    return () => {
      if (matchMedia.removeListener) {
        matchMedia.removeListener(handleChange);
      } else {
        matchMedia.removeEventListener("change", handleChange);
      }
    };
  }, [query]);

  return matches;
};
